import { useEffect, useState } from 'react'
import { CustomEnumValue } from '../../../../../lib/commons/appFunction'
import { StatusComboBox } from '../../../../../view/components/comboBox/StatusComboBox'
import { filterValuesByCombination } from '../../../../../lib/commons/customEnum'
import objects from '../../../../../utils/objects'
import { ProgressIcon } from '../../../commons/AgGrid/components/cell/custom/wbsItemStatus/ProgressIcon'
import {
  ProgressIconArea,
  StatusRootDiv,
} from '../cellRenderer/WbsItemStatusCellRenderer'
import usePrevious from '../../../../hooks/usePrevious'
import { CustomCellEditorProps } from 'ag-grid-react'

type Props = {
  customEnumCode?: string
  combinedValuePath?: (combinedEnumCode: string) => string
  valuesAllowed?: CustomEnumValue[]
  popperOpen?: boolean
} & CustomCellEditorProps

export const WbsItemStatusCellEditor = ({
  customEnumCode,
  combinedValuePath,
  value,
  api,
  context,
  data,
  onValueChange,
}: Props) => {
  const [val, setVal] = useState(value ?? '')
  const wbsItem = data?.body?.wbsItem ?? data?.wbsItem

  let options: CustomEnumValue[] = []
  if (customEnumCode) {
    options = filterValuesByCombination(context[customEnumCode], code =>
      objects.getValue(data, combinedValuePath?.(code))
    )
  }

  const prevVal = usePrevious(val)
  useEffect(() => {
    if (val && prevVal && val !== prevVal) {
      api.stopEditing()
    }
  }, [api, val, prevVal])

  if (!options) return <></>

  return (
    <StatusRootDiv>
      <ProgressIconArea>
        <ProgressIcon wbsItem={wbsItem} fontSize={20} />
      </ProgressIconArea>
      <StatusComboBox
        value={val}
        options={options}
        dropDownListOpen={true}
        onChange={newValue => {
          onValueChange(newValue)
          setVal(newValue)
        }}
        onClick={() => {
          api.stopEditing()
        }}
      />
    </StatusRootDiv>
  )
}
